import { useSelector } from "react-redux";

export default function useTourneyFilterSortConfig() {
  const tourneyFilterSortConfig = useSelector(
    (state) => state?.lobby?.tourneyFilterSortConfig
  );

  if (!tourneyFilterSortConfig) {
    console.warn(`Tourney not found`);
    return null;
  }

  return tourneyFilterSortConfig;
}
